import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Mail, MapPin } from 'lucide-react';
import { mockData } from '../mock';

const Contact = () => {
  const { organization } = mockData;

  const emailContacts = [
    {
      title: 'General Inquiries',
      email: organization.emails.general,
      description: 'Questions about our organization, services, or general information'
    },
    {
      title: 'Get Help (Need Pet Assistance)',
      email: organization.emails.gethelp,
      description: 'If you need assistance with pet supplies or support for your pet'
    },
    {
      title: 'Donation Questions',
      email: organization.emails.donations,
      description: 'Questions about what to donate or arranging a donation drop-off'
    },
    {
      title: 'Volunteer Interest',
      email: organization.emails.volunteer,
      description: 'Interested in volunteering or helping with our mission'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <section className="bg-gradient-to-b from-mauve-100 to-white py-16 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-darkslate-700 mb-4">
            Contact Us
          </h1>
          <p className="text-lg text-darkslate-500">
            We're here to help. Reach out with questions, donation inquiries, or if you need assistance.
          </p>
        </div>
      </section>

      {/* Contact Information */}
      <section className="py-12 px-4">
        <div className="max-w-5xl mx-auto">
          <div className="grid gap-8">
            {/* Location Card */}
            <Card className="border-2 border-mauve-200">
              <CardHeader>
                <CardTitle className="text-2xl text-darkslate-700 flex items-center gap-2">
                  <MapPin className="h-6 w-6 text-olive-500" />
                  Our Location
                </CardTitle>
              </CardHeader>
              <CardContent className="text-darkslate-600">
                <p className="font-semibold text-lg">{organization.location}</p>
                <p className="text-darkslate-500 mt-2">
                  Serving {organization.serviceArea}
                </p>
              </CardContent>
            </Card>

            {/* Email Contacts */}
            <div>
              <h2 className="text-2xl font-bold text-darkslate-700 mb-6 flex items-center gap-2">
                <Mail className="h-6 w-6 text-amber-500" />
                Email Us Directly
              </h2>
              <div className="grid md:grid-cols-2 gap-6">
                {emailContacts.map((contact, index) => (
                  <Card key={index} className="border-2 border-mauve-200 hover:border-olive-400 transition-colors">
                    <CardHeader>
                      <CardTitle className="text-lg text-darkslate-700">{contact.title}</CardTitle>
                    </CardHeader>
                    <CardContent className="space-y-3">
                      <p className="text-sm text-darkslate-500">{contact.description}</p>
                      <a 
                        href={`mailto:${contact.email}`}
                        className="inline-flex items-center gap-2 text-red-600 hover:text-red-700 font-semibold transition-colors"
                      >
                        <Mail className="h-4 w-4" />
                        {contact.email}
                      </a>
                    </CardContent>
                  </Card>
                ))}
              </div>
            </div>

            {/* Urgent Help Card */}
            <Card className="border-2 bg-amber-50 border-amber-300">
              <CardHeader>
                <CardTitle className="text-xl text-darkslate-700">Need Immediate Help?</CardTitle>
              </CardHeader>
              <CardContent className="text-darkslate-600">
                <p>
                  If you're facing an emergency situation with your pet and need immediate assistance, please email us at{' '}
                  <a href={`mailto:${organization.emails.gethelp}?subject=URGENT`} className="font-semibold text-red-600 hover:text-red-700 underline">
                    {organization.emails.gethelp}
                  </a>
                  {' '}with "URGENT" in the subject line.
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
